export default __webpack_public_path__ + "static/media/youtube.21cea619.svg";